import * as React from "react";
import { NextPageWithLayout } from "@pages/_app";
import AuthLayout from "@layouts/auth";
import Button from "@components/button";
import InputPhone from "@components/input-phone";
import { withUrqlClient } from "next-urql";
import { useMutation } from "urql";
import { SendForgotPasswordOTP } from "@graphql/mutations/auth.mutation";
import {
  SendForgetPasswordOtpMutation,
  SendForgetPasswordOtpMutationVariables,
} from "@graphql/types";
import ResetPasswordForm from "@components/reset-password-page";
import Head from "next/head";

type Props = {
  phoneNumber: string;
  setPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
  setNextScreen: React.Dispatch<React.SetStateAction<number>>;
};

const ForgotPasswordForm: React.FC<Props> = ({
  setNextScreen,
  phoneNumber,
  setPhoneNumber,
}) => {
  const [forgotPasswordResult, forgotPasswordFn] = useMutation<
    SendForgetPasswordOtpMutation,
    SendForgetPasswordOtpMutationVariables
  >(SendForgotPasswordOTP);
  return (
    <div className="px-4 w-full">
      <h1 className="font-libre text-2xl mb-3">Forgot Password</h1>
      <p className="text-base font-light font-sfpro">
        Sign-in to your favorite wedding planning tool
      </p>
      <form className="flex flex-col justify-start items-start gap-6 mt-8 xs:mt-12 w-full">
        <InputPhone
          placeholder="+234"
          name="Phone"
          label="Phone Number(Whatsapp)"
          value={phoneNumber}
          setValue={setPhoneNumber}
        />
        <Button
          type="button"
          label="Send Instructions"
          loader={forgotPasswordResult.fetching}
          disabled={forgotPasswordResult.fetching}
          handleClick={() => {
            forgotPasswordFn({ phone: phoneNumber }).then(() => {
              setNextScreen(2);
            });
          }}
        >
          Send Instructions
        </Button>
      </form>
    </div>
  );
};

const ForgotPassword: NextPageWithLayout = () => {
  const [nextScreen, setNextScreen] = React.useState(1);
  const [phoneNumber, setPhoneNumber] = React.useState("");

  return (
    <>
      <Head>
        <title>Inawo Vendors | Forgot Password</title>
        <meta name="title" content="Inawo Vendors | Forgot Password" />
        <meta
          name="description"
          content="Recover your Password on Inawo Vendors"
        />
      </Head>
      <div className="max-w-lg mb-12 w-full px-4">
        {nextScreen === 1 ? (
          <ForgotPasswordForm
            setNextScreen={setNextScreen}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
          />
        ) : nextScreen === 2 ? (
          <ResetPasswordForm phoneNumber={phoneNumber} />
        ) : null}
      </div>
    </>
  );
};

ForgotPassword.getLayout = function getLayout(page: React.ReactElement) {
  return <AuthLayout>{page}</AuthLayout>;
};

export default withUrqlClient(
  (_ssr) => ({
    url: process.env.NEXT_PUBLIC_API_URL!,
  }),
  { ssr: false }
)(ForgotPassword);
